import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import { CDN_LINK } from "@globalConfig";
import useHelpers from "@hooks/useHelpers";
import { trackEvents } from "@/common/events/events";
var EligibilityComponent = function EligibilityComponent(_ref) {
  var design = _ref.design,
    _ref$postID = _ref.postID,
    postID = _ref$postID === void 0 ? null : _ref$postID,
    _ref$postCondition = _ref.postCondition,
    postCondition = _ref$postCondition === void 0 ? null : _ref$postCondition,
    entryPoint = _ref.entryPoint,
    _ref$skipFlag = _ref.skipFlag,
    skipFlag = _ref$skipFlag === void 0 ? false : _ref$skipFlag;
  var _useTranslation = useTranslation(["web_common"]),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  if (design === "card") {
    return /*#__PURE__*/React.createElement("a", {
      onClick: function onClick() {
        trackEvents("eligibility_check_opened", {
          referral_location: entryPoint
        });
      },
      "data-name": !skipFlag && "EligibilityCheck",
      href: createUrl("/site/finance-eligibility?reset_eligibility=true"),
      className: "flex p-[24px_16px] flex-col justify-center items-center gap-3 rounded-[8px] bg-[#7F95FF]"
    }, /*#__PURE__*/React.createElement("img", {
      className: "max-md:w-[48px] max-md:h-[48px]",
      src: CDN_LINK + "/assets/images/EligibilityImage.svg",
      alt: "Eligibility",
      width: "120px",
      height: "120px"
    }), /*#__PURE__*/React.createElement("strong", {
      className: "text-white text-xl font-bold leading-[32px] mt-3 mb-2 text-center max-md:mt-0 max-md:!mb-0 max-md:text-lg max-md:leading-[24px]"
    }, t("هل أنت مؤهل للتمويل؟", {
      ns: "web_sell_trade"
    })), /*#__PURE__*/React.createElement("span", {
      className: "text-white text-sm font-semibold leading-[24px] mb-6 text-center max-md:text-xs max-md:font-semibold max-md:leading-[24px] max-md:mb-0"
    }, t("املأ استبيان سريع، وتأكد من أهليتك للحصول على تمويل", {
      ns: "web_sell_trade"
    })), /*#__PURE__*/React.createElement("div", {
      className: "flex p-[12px_16px] justify-center items-center self-stretch text-[#3C56D4] text-lg font-bold leading-[24px] rounded-[4px] bg-white mt-auto"
    }, /*#__PURE__*/React.createElement("strong", null, t("تحقق الآن", {
      ns: "web_sell_trade"
    }))));
  }
  if (design === "banner") {
    return /*#__PURE__*/React.createElement("a", {
      onClick: function onClick() {
        trackEvents("eligibility_check_opened", {
          referral_location: entryPoint
        });
      },
      "data-name": !skipFlag && "EligibilityCheck",
      href: createUrl("/site/finance-eligibility?reset_eligibility=true"),
      className: "flex gap-[35px]  items-center rounded-[16px] bg-[#7F95FF] px-8 h-[140px]"
    }, /*#__PURE__*/React.createElement("img", {
      src: CDN_LINK + "/assets/images/EligibilityImage.svg",
      alt: "Eligibility",
      width: "120px",
      height: "120px"
    }), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col gap-[7px] justify-start items-start"
    }, /*#__PURE__*/React.createElement("strong", {
      className: "text-white text-xl font-bold leading-[32px] text-center"
    }, t("هل أنت مؤهل للتمويل؟", {
      ns: "web_sell_trade"
    })), /*#__PURE__*/React.createElement("span", {
      className: "text-white text-sm font-semibold leading-[24px] text-center"
    }, t("املأ استبيان سريع، وتأكد من أهليتك للحصول على تمويل", {
      ns: "web_sell_trade"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "flex p-[12px_16px] justify-center items-center text-[#3C56D4] text-lg font-bold leading-[24px] rounded-[4px] bg-white ar:mr-auto en:ml-auto"
    }, /*#__PURE__*/React.createElement("strong", null, t("تحقق الآن", {
      ns: "web_sell_trade"
    }))));
  }
  if (design === "button") {
    return /*#__PURE__*/React.createElement("a", {
      onClick: function onClick() {
        trackEvents("eligibility_check_opened", {
          referral_location: entryPoint
        });
      },
      "data-name": !skipFlag ? "EligibilityCheck" : "skippingCheck",
      href: createUrl("/site/finance-eligibility" + "?post_id=".concat(postID, "&condition_id=").concat(postCondition, "&reset_eligibility=true")),
      className: "border-solid border border-[#7F95FF] w-full h-[40px] mt-6 flex items-center justify-between p-[8px_12px] rounded-[4px]"
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-[#3C56D4] text-xs font-bold leading-[16px]"
    }, t("هل أنت مؤهل للتمويل؟", {
      ns: "web_sell_trade"
    })), /*#__PURE__*/React.createElement("img", {
      className: "transform en:rotate-180",
      src: CDN_LINK + "/assets/images/lightBlueArrow.svg",
      alt: t("هل أنت مؤهل للتمويل؟", {
        ns: "web_sell_trade"
      })
    }));
  }
  return null;
};
export default EligibilityComponent;